const initialState = { checked: false };

export function authStatusReducer(state = initialState, action) {
  switch (action.type) {
    case "AUTH_CHECKED":
      return { checked: true };
    default:
      return state;
  }
}
